import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import type { EndpointBuilder } from '@reduxjs/toolkit/query/endpointDefinitions';
import type { FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/fetchBaseQuery';
import type { User } from '../../api/user';
import type { ApiResponse } from '../../types/api';
import type { RootState } from '../index';

// User API endpoints
export const userApiEndpoints = (builder: EndpointBuilder<BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, never, 'api'>) => ({
  getCurrentUser: builder.query<User, void>({
    query: () => '/user/profile',
    transformResponse: (response: ApiResponse<User>) => response.data,
    providesTags: [{ type: 'User', id: 'PROFILE' }],
    async onQueryStarted(arg, { getState, queryFulfilled, dispatch }) {
      const state = getState() as RootState;
      if (!state.auth.token || !state.auth.isAuthenticated) {
        dispatch(api.util.resetApiState());
        return;
      }
    }
  }),
  
  updateProfile: builder.mutation<User, { full_name: string }>({
    query: (data) => ({
      url: '/user/profile',
      method: 'PUT',
      body: data,
    }),
    invalidatesTags: [{ type: 'User', id: 'PROFILE' }],
  }),
  
  updatePassword: builder.mutation<
    { message: string },
    { current_password: string; new_password: string }
  >({
    query: (data) => ({
      url: '/user/change-password',
      method: 'POST',
      body: data,
    }),
  }),
}); 